import dayjs from 'dayjs';
import fixDateTimezone from './fixDateTimezone';

// Записи живут во времени дилера (Asia/Almaty): бэкенд принимает наивную
// строку без смещения и трактует её как алматинскую, а списки CRM тем же
// поясом её и показывают.
//
// Карточка записи раньше считала дату в поясе браузера. Менеджер западнее
// Алматы видел не то время (запись 05:30 показывалась как 01:30), а сохранение
// собирает дату из показанного — поэтому обычное «Сохранить», без единой
// правки, сдвигало запись на разницу поясов. Каждый раз ещё раз.
//
// Все три функции дают одинаковый результат в любом поясе браузера.

/** Время записи «HH:mm» во времени дилера. */
export const timeOfRecord = (date) => (date ? fixDateTimezone(date).format('HH:mm') : '');

/**
 * Значение для датапикера: полночь по локали браузера на тот календарный день,
 * который у записи в Алматы.
 *
 * Именно день, а не исходный момент: запись под полночь у того, кто западнее,
 * иначе показывалась бы предыдущим числом — и таким же уезжала при сохранении.
 */
export const datePickerValue = (date) => {
  if (!date) return undefined;
  const almaty = fixDateTimezone(date);
  return new Date(almaty.year(), almaty.month(), almaty.date());
};

/**
 * День «YYYY-MM-DD» для отправки на бэкенд.
 *
 * Было `toLocaleDateString().split('.').reverse().join('-')` — расчёт на
 * русский формат `30.10.2025`. На англоязычном браузере `toLocaleDateString`
 * отдаёт `10/30/2025`, точек нет, split ничего не делает, и на сервер уходила
 * строка в чужом формате. Разобралась она там только по везению культуры.
 *
 * Пустое или битое значение — сегодняшний день у дилера, а не у браузера.
 */
export const dayString = (value) => {
  // dayjs(undefined) — это «сейчас», и такое значение считается валидным. Из-за
  // этого пустая дата уходила по первой ветке и давала день браузера, хотя по
  // задумке пустое и битое значение одинаково означают сегодня у дилера.
  // Расхождение видно только западнее Алматы: на UTC-машине с 19:00 до полуночи
  // день браузера и день дилера разные — на этом и падал тест в CI.
  const parsed = value == null ? null : dayjs(value);
  return (parsed?.isValid() ? parsed : fixDateTimezone(new Date())).format('YYYY-MM-DD');
};
